module.exports = __webpack_public_path__ + "img/ajout_film.0de8163c.png";